import { Injectable } from '@angular/core';
import * as d3 from 'd3';
import { Subject } from 'rxjs';

@Injectable()
export class DrawingContactService {


  svgContact: any;

  knob_image_width: number;
  knob_image_height: number;

  knob_image_offsetX: number;
  knob_image_offsetY: number;

  knob_scale: number;

  rotation_timeout: any;
  rotating = false;
  rotation_angle = -40;

  mobile_image_width: number;
  mobile_image_height: number;

  mobile_image_offsetX: number;
  mobile_image_offsetY: number;

  animating_mobile_hand = false;

  mobile_scale: number;
  totalLength_path_forcefeedback: any;
  shakeInterval: any;

  playClick: Subject<any> = new Subject();
  playMechanicalClick: Subject<any> = new Subject();
  hapticFeedback: Subject<any> = new Subject();

  constructor() {}


  playHapticFeedback(value: number) {
    this.hapticFeedback.next(value);
  }


  draw() {

    d3.selectAll('#svgContact').remove();

    this.svgContact = d3.select('#svgBg')
      .append('svg')
      .attr('width', window.innerWidth)
      .attr('height', () => window.innerWidth < window.innerHeight ? window.innerWidth * 1.2 : window.innerHeight)
      .attr('id', 'svgContact');

    if (window.innerWidth > 1000) {
      this.drawKnob();
      this.drawHandKnob();
    }

    if (window.innerWidth <= 1000 || window.innerWidth >= 1600) {
      this.drawMobile();
      this.drawMobileHand();
    }
  }

  animateKnob(i: number) {

    this.svgContact.select('#knob_group')
      .attr('transform', 'translate(' + (this.knob_image_offsetX + (this.knob_image_width * 0.324)) + ', ' + (this.knob_image_offsetY + (this.knob_image_height * 0.5)) + '), rotate(' + this.rotation_angle + ')')
      .transition()
      .duration(300)
      .ease(d3.easeBounceInOut)
      .attr('transform', 'translate(' + (this.knob_image_offsetX + (this.knob_image_width * 0.324)) + ', ' + (this.knob_image_offsetY + (this.knob_image_height * 0.5)) + '), rotate(' + (this.rotation_angle + 20) + ')')

    this.svgContact.select('#forcefeedback')
      .style('stroke', '#8f8f8e')
      .attr('stroke-dasharray', this.totalLength_path_forcefeedback + ' ' + this.totalLength_path_forcefeedback)
      .attr('stroke-dashoffset', this.totalLength_path_forcefeedback / 9 * (9 - i + 1))
      .transition()
      .duration(300)
      .ease(d3.easeBounceInOut)
      .attr('stroke-dashoffset', this.totalLength_path_forcefeedback / 9 * (9 - i));

    this.playMechanicalClick.next();
    this.playHapticFeedback(100);
    this.rotation_angle += 20;
  }

  animateHand() {
    this.svgContact.select('#hand_knob')
      .attr('transform', 'translate(200,0), rotate(4)')
      .transition()
      .duration(300)
      .ease(d3.easeBounceInOut)
      .attr('transform', 'translate(200,0), rotate(-2)');
  }

  drawKnob() {


    this.knob_image_width = window.innerWidth * 0.285;
    this.knob_image_offsetX = window.innerWidth * 0.68;
    this.knob_image_offsetY = window.innerHeight * 0.1;

    if (window.innerWidth < 1200) {
      this.knob_image_width = window.innerWidth * 0.48;
      this.knob_image_offsetX = window.innerWidth * 0.58;
      this.knob_image_offsetY = window.innerHeight * 0.5 - (this.knob_image_width/2);
    } else if (window.innerWidth < 1400) {
      this.knob_image_width = window.innerWidth * 0.45;
      this.knob_image_offsetX = window.innerWidth * 0.55;
      this.knob_image_offsetY = window.innerHeight * 0.5 - (this.knob_image_width/2);
    } else if (window.innerWidth < 1600) {
      this.knob_image_width = window.innerWidth * 0.38;
      this.knob_image_offsetX = window.innerWidth * 0.58;
      this.knob_image_offsetY = window.innerHeight * 0.5 - (this.knob_image_width/2);
    }

    this.knob_image_height = this.knob_image_width * (330 / 512);
    this.knob_scale = this.knob_image_width / 512;


    const group = this.svgContact.append('g')
      .attr('id', 'knob_group')
      .attr('transform', 'translate(' + (this.knob_image_offsetX + (this.knob_image_width * 0.324)) + ', ' + (this.knob_image_offsetY + (this.knob_image_height * 0.5)) + '), rotate(' + this.rotation_angle + ')')
      .on('mouseenter', () => {
          this.svgContact.select('#hand_knob').attr('transform', 'translate(200,0), rotate(4)');

          if (!this.rotating) {

            this.rotating = true;
            for (let i = 0; i < 9; i++) {
              setTimeout(() => {
                this.animateKnob(i + 1);
                this.animateHand();
              }, (400 * i));
            }

            setTimeout(() => {
              this.svgContact.select('#forcefeedback').style('stroke', 'transparent');
              this.rotating = false;

              this.svgContact.select('#hand_knob').attr('transform', 'translate(200,0), rotate(0)');
            }, 3600);
          }

      });

    group.append('circle')
      .attr('r', this.knob_image_height * 0.285)
      .attr('cx', 0)
      .attr('cy', 0)
      .style('fill', '#9fddf9');

    const r =  this.knob_image_height * 0.35;
    const data = [
      [
        Math.sin(0) * r,
        Math.cos(0) * r
      ],
      [
        Math.sin(Math.PI / 3 * 2) * r,
        Math.cos(Math.PI / 3 * 2) * r
      ],
      [
        Math.sin(Math.PI / 3 * 4) * r,
        Math.cos(Math.PI / 3 * 4) * r
      ]
    ]

    group.selectAll('polygon')
      .data(data)
      .enter()
      .append('polygon')
      .attr('points', (d) => data)
      .style('fill', '#f27fb2');

    const path = 'M192.1,322.7c-8.5,1.4-19.5-29.4-27.9-29.4c-8.6-0.1-20.1,30.5-28.3,29c-8.4-1.6-8.2-34.3-16.1-37.2c-8-3-29.3,21.8-36.5,17.5c-7.3-4.4,4.1-34.9-2.4-40.5c-6.4-5.5-34.9,10.6-40.4,4c-5.3-6.5,15.7-31.4,11.6-38.9c-4.2-7.3-36.4-2-39.3-10.1C10,209.2,38.4,193,37,184.5S3.4,169.9,3.5,161.6c0.1-8.6,32.3-14.1,33.9-22.4c1.6-8.4-26.5-25-23.6-33c3-8,35.1-2.1,39.4-9.4c4.4-7.3-16.4-32.6-10.9-39S76,67.9,82.6,62.5c6.5-5.3-4.4-36.2,3.1-40.4c7.3-4.2,28.1,21,36.2,18.2c7.9-2.8,8.2-35.4,16.7-36.9';

    const group2 = this.svgContact.append('g')
      .attr('transform', 'translate(' + this.knob_image_offsetX + ', ' + this.knob_image_offsetY + '), scale(' + this.knob_scale + ')');

    const forcefeedback = group2.append('path')
      .attr('d', path)
      .attr('id', 'forcefeedback')
      .style('fill', 'none')
      .style('stroke', 'transparent') //#8f8f8e
      .style('stroke-width', this.knob_image_width * 0.016);

    this.totalLength_path_forcefeedback = forcefeedback.node().getTotalLength();

  }

  drawHandKnob() {
    const group = this.svgContact.append('g')
      .attr('id', 'hand_knob_group')
      .attr('transform', 'translate(' + (this.knob_image_offsetX + (this.knob_image_width * 0.02)) + ', ' + (this.knob_image_offsetY - (this.knob_image_height * 0.02)) + '), scale(' + this.knob_scale + ')');

    group.append('rect')
      .attr('x', 317)
      .attr('y', 164)
      .attr('width', 450)
      .attr('height', 60)
      .style('fill', '#ccc');

    const path = 'M74.8,316H44v-12.1c0-15.1,12.3-27.5,27.5-27.5h3.4c14.2,0,25.6-11.5,25.6-25.6V65.2c0-14.2-11.5-25.6-25.6-25.6H25.4C11.3,39.6,0,28.2,0,14.2V0h74.9c36,0,65.2,29.2,65.2,65.2v185.5C140,286.8,110.8,316,74.8,316z';

    group.append('path')
      .attr('id', 'hand_knob')
      .attr('d', path)
      .style('fill', '#eee')
      .attr('transform', 'translate(200,0), rotate(0)')
      .attr('transform-origin', '0px 194px');

  }



  drawMobile() {

    this.mobile_image_width = window.innerWidth * 0.25;
    this.mobile_image_offsetX = window.innerWidth * 0.38;


    if (window.innerWidth < 800) {
      this.mobile_image_width = window.innerWidth * 0.7;
      this.mobile_image_offsetX = window.innerWidth * 0.15;
    } else if (window.innerWidth < 1000) {
      this.mobile_image_width = window.innerWidth * 0.5;
      this.mobile_image_offsetX = window.innerWidth * 0.3;
    } else if (window.innerWidth < 1400) {
      this.mobile_image_width = window.innerWidth * 0.38;
      this.mobile_image_offsetX = window.innerWidth * 0.36;
    }

    this.mobile_image_height = this.mobile_image_width * (660 / 528);
    this.mobile_image_offsetY = window.innerHeight - this.mobile_image_height;
    if (window.innerWidth < 1000) {
      this.mobile_image_offsetY = (window.innerWidth * 1.2) - this.mobile_image_height;
    } else if (window.innerWidth < 1400) {
      this.mobile_image_offsetY = window.innerHeight - this.mobile_image_height - 90;
    }

    this.mobile_scale = this.mobile_image_width / 528;




    const group = this.svgContact.append('g')
      .attr('id', 'mobile_group')
      .attr('transform', 'translate(' + (this.mobile_image_offsetX) + ', ' + (this.mobile_image_offsetY) + ')');


    group.append('rect')
      .attr('x', this.mobile_image_width * 0.607)
      .attr('y', 0)
      .attr('width', this.mobile_image_width * 0.31)
      .attr('height', this.mobile_image_height * 0.5)
      .style('opacity', 0.7)
      .style('fill', '#9fddf9');

    group.append('circle')
      .attr('cx', this.mobile_image_width * 0.77)
      .attr('cy', this.mobile_image_height * 0.445)
      .attr('r', this.mobile_image_width * 0.0507)
      .style('fill', '#f27fb2');

    group.append('rect')
      .attr('x', this.mobile_image_width * 0.896)
      .attr('y', this.mobile_image_height * 0.0378)
      .attr('width', this.mobile_image_width * 0.0442)
      .attr('height', this.mobile_image_height * 0.505)
      .style('fill', '#832990');

    group.append('circle')
      .attr('cx', this.mobile_image_width * 0.943)
      .attr('cy', this.mobile_image_height * 0.445)
      .attr('r', this.mobile_image_width * 0.0625)
      .style('fill', '#f27fb2')
      .style ('mix-blend-mode', 'color-dodge');

    const zigZagWidth = this.mobile_image_width * 0.05078;
    const zigZagHeight = this.mobile_image_height * 0.351;

    const data = 'M0,0L' + zigZagWidth + ',' + (zigZagHeight / 6) + 'L0,' + ((zigZagHeight / 6) * 2) + 'L' + zigZagWidth + ',' + ((zigZagHeight / 6) * 3) + 'L0' + ',' + ((zigZagHeight / 6) * 4) + 'L' +
                  zigZagWidth + ',' + ((zigZagHeight / 6) * 5) + 'L0' + ',' + (zigZagHeight);

    const data2 = 'M' + zigZagWidth + ',0L0,' + (zigZagHeight / 6) + 'L' + zigZagWidth + ',' + ((zigZagHeight / 6) * 2) + 'L0,' + ((zigZagHeight / 6) * 3) + 'L' + zigZagWidth + ',' + ((zigZagHeight / 6) * 4) + 'L0,' +
                   ((zigZagHeight / 6) * 5) + 'L' + zigZagWidth + ',' + (zigZagHeight);

    group.append('path')
      .attr('d', data)
      .attr('class', 'zigzag')
      .attr('stroke', 'transparent') //#8f8f8e
      .attr('stroke-width', this.mobile_image_width * 0.0175)
      .attr('fill', 'none')
      .attr('transform', 'translate(' + (this.mobile_image_width * 0.818) + ', ' + (this.mobile_image_height * 0.06) + ')');

    group.append('path')
      .attr('d', data2)
      .attr('class', 'zigzag')
      .attr('stroke', 'transparent') //#8f8f8e
      .attr('stroke-width', this.mobile_image_width * 0.0175)
      .attr('fill', 'none')
      .attr('transform', 'translate(' + (this.mobile_image_width * 0.97) + ', ' + (this.mobile_image_height * 0.06) + ')');

  }

  shakeMobile() {
    this.svgContact.select('#mobile_group')
      .attr('transform', 'translate(' + (this.mobile_image_offsetX) + ', ' + (this.mobile_image_offsetY) + ')')
      .transition()
      .duration(80)
      .ease(d3.easeBounceInOut)
      .attr('transform', 'translate(' + (this.mobile_image_offsetX + 10) + ', ' + (this.mobile_image_offsetY) + ')')
  }

  drawMobileHand() {
    const group = this.svgContact.append('g')
      .attr('id', 'mobile_hand_group')
      .attr('transform', 'translate(' + (this.mobile_image_offsetX) + ', ' + (this.mobile_image_offsetY + (this.mobile_image_height * 0.409)) + '), scale(' + this.mobile_scale + ')')
      .on('mouseenter', () => {
        if (!this.animating_mobile_hand) {
          clearInterval(this.shakeInterval);

          this.animating_mobile_hand = true;
          this.svgContact.select('#mobile_hand_group')
            .attr('transform', 'translate(' + (this.mobile_image_offsetX) + ', ' + (this.mobile_image_offsetY + (this.mobile_image_height * 0.409)) + '), scale(' + this.mobile_scale + ')')
            .transition()
            .duration(200)
            .ease(d3.easeLinear)
            .attr('transform', 'translate(' + (this.mobile_image_offsetX + (this.mobile_image_width * 0.05)) + ', ' + (this.mobile_image_offsetY + (this.mobile_image_height * 0.409)) + '), scale(' + this.mobile_scale + ')');

          this.svgContact.selectAll('.zigzag').attr('stroke', '#8f8f8e');
          this.playClick.next();


          setTimeout(() => {
            this.shakeInterval = setInterval(() => { this.shakeMobile() }, 100);
            this.playHapticFeedback(200);
          }, 200);


          setTimeout(() => {
            this.svgContact.selectAll('.zigzag').attr('stroke', 'transparent');
            clearInterval(this.shakeInterval);
            this.animating_mobile_hand = false;
          }, 1000);



        }
      })
      .on('mouseleave', () => {
        this.svgContact.select('#mobile_hand_group')
          .attr('transform', 'translate(' + (this.mobile_image_offsetX + (this.mobile_image_width * 0.05)) + ', ' + (this.mobile_image_offsetY + (this.mobile_image_height * 0.409)) + '), scale(' + this.mobile_scale + ')')
          .transition()
          .duration(200)
          .ease(d3.easeLinear)
          .attr('transform', 'translate(' + (this.mobile_image_offsetX) + ', ' + (this.mobile_image_offsetY + (this.mobile_image_height * 0.409)) + '), scale(' + this.mobile_scale + ')');
      });

    const handPath = 'M104.7,0C46.9,0,0,46.9,0,104.7v285.9h72.9V209.2c0.4,0,0.6,0,1,0h103.7V0H104.7z';

    const data = [ { y: 0 }, { y: 54.1 }, { y: (54.1 * 2) }, { y: (54.1 * 3) } ];

    group.selectAll('rect.finger')
      .data(data)
      .enter()
      .append('rect')
      .attr('class', 'finger')
      .attr('rx', 23.5)
      .attr('ry', 23.5)
      .attr('x', 160)
      .attr('y', (d) => d.y)
      .attr('width', (d, i) => i === 0 ? 230 : 122)
      .attr('height', 47)
      .style('fill', '#eee');

    group.append('path')
      .attr('d', handPath)
      .attr('fill', '#ccc');

    group.append('circle')
      .attr('class', 'nail')
      .attr('r', 20)
      .attr('cx', 359)
      .attr('cy', 24)
      .style('fill', '#832990');

    group.append('rect')
      .attr('class', 'nail')
      .attr('width', 33)
      .attr('height', 40)
      .attr('x', 359)
      .attr('y', 4)
      .style('fill', '#832990');
  }
}

